import { ModularTexture } from './ModularTexture';

export default ModularTexture;
